import { Component, OnInit, AfterViewInit } from "@angular/core";
import { SheduleAppointmentService } from '../services/shedule-appointment.service';
import { SharedServiceService } from '../services/shared-service.service';
import { WSCallDetailsData } from "src/app/model/creat-update-lead";
import { IwService } from '../services/iw.service';
import { Router } from '@angular/router';
import { ISTATACARD, SCHEDULE_APPOINTMENT, DOC_UPLOAD_LINK, GENERIC_ERROR, BRAND_APPROVED_ERRORS, IS_CAMPAIGN } from '../config/app-settings.config';
import { ThemeService } from '../services/theme.service';
declare var book_appointment: Function;
declare var $: any;
declare var _satellite: any;
declare var analytics: any;


import { SBICARDTheme } from 'src/app/config/app-settings.config';
import cssVars from "css-vars-ponyfill";

@Component({
  selector: 'app-schedule-appointment',
  templateUrl: './schedule-appointment.component.html',
  styleUrls: ['./schedule-appointment.component.scss']
})
export class ScheduleAppointmentComponent implements OnInit, AfterViewInit {
  slots: any;
  dates: any;
  fetchAppointmentSlotsDetails: any;
  wsDetails = new WSCallDetailsData();

  status: boolean = false;
  selected: any;
  addSelected: any;
  slotSelected: any;
  flag: boolean = false;
  bookAppointmentRequestBody: any;
  errorBookAppointment: String;
  bookAppointmentDetails: any;
  addType: string;

  addressLine1: any;
  addressLine2: any;
  pinCode: any;
  city: any;
  state: any;
  landmark: any;
  fetchAppointment: any;
  fetchAppointmentFlag: boolean = false;
  eapplySchAppointmentLabel: any;
  popupEnable: boolean = true;
  docUploadStatus: boolean = false;
  TATACARD = ISTATACARD;
  errorTriangleImage: any;
  blueTickImage: any;
  nationalHolidayFlag: any = false;
  schedule_appointment: any;
  errorMessage: any;
  applicantName: any;
  applicantApplicationNumber: any;
  displayOffice: boolean = true;
  offerFlag: boolean;
  location: any;
  timeSlot: any;
  disableBookAppointment = 0;
  partnerCode: any;
  //partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');


  responseTheme: any;
  themeObj: any;
  

  constructor(
    private appointmentService: SheduleAppointmentService, 
    private sharedService: SharedServiceService, 
    private iw: IwService, 
    private router: Router,
    private themeService: ThemeService
    ) { 
      this.partnerCode = this.themeService.partnerCode;
      this.partnerCode = sessionStorage.getItem('partner-code');
      console.log("Parner code is", this.partnerCode);
      //this.themeService.getThemeData(this.partnerCode);

      this.themeService.getThemeData(this.partnerCode).subscribe((result: any) => {
        if (result) {
          if (result.partner_id && result.partner_id === this.partnerCode) {
            this.responseTheme = result;
            this.themeObj = this.responseTheme;
            this.themeService.setThemePage(this.themeObj);
            cssVars({ variables: this.themeObj });//Theme change for IE 
          } else {
            // this.errorMsg = 'JSON not found';
            this.themeService.setThemePage(SBICARDTheme);
            cssVars({ variables: SBICARDTheme });//Theme change for IE 
          }
        } else {
          // this.errorMsg = 'JSON error';
          this.themeService.setThemePage(SBICARDTheme);
          cssVars({ variables: SBICARDTheme });//Theme change for IE 
        }
      },
        (error) => {
          // this.errorMsg = 'Service not available';
          this.themeService.setThemePage(SBICARDTheme);
          cssVars({ variables: SBICARDTheme });//Theme change for IE 
        }
      );

    }

  ngOnInit() {
    if(!this.sharedService.fromSwiftJourney){
      if(window['analytics'] && this.sharedService.trackApplicationResponse){
        analytics.track('eapply__document_uploaded', {
  
          'MODE_OF_CONVERSION': '',
          'IS_ORGANIC': 'N',
          'SOURCE_GEM_ID1': this.sharedService.paramsgemid1,
          'SOURCE_GEM_ID2': this.sharedService.paramsgemid2,
          'SOURCE_PAGE_URL': window["digitalData"].page.SOURCE_PAGE_URL,
          'CHANNEL_NAME': this.sharedService.paramschannel,
          'JOURNEY_NAME': 'EAPPLY',
          'CITY': this.wsDetails.WSCallUserCity,
          'IS_DOCUMENT_UPLOADED': this.sharedService.navigateToDocUpload,
          'card_type' : this.sharedService.sbic_card_Type,
           'First_Name' : this.sharedService.fromSwiftJourney ? this.sharedService.trackApplicationResponse.data.applicantDetails.firstName : this.sharedService.trackApplicationResponse.eapplyApplicantDetails.firstName,
          'Last_Name' : this.sharedService.fromSwiftJourney ? this.sharedService.trackApplicationResponse.data.applicantDetails.lastName : this.sharedService.trackApplicationResponse.eapplyApplicantDetails.lastName,
          'Mobile_No' :this.sharedService.fromSwiftJourney ? this.sharedService.trackApplicationResponse.data.applicantDetails.mobileNumber : this. sharedService.trackApplicationResponse.eapplyApplicantDetails.mobileNumber,
          'Email' :this.sharedService.fromSwiftJourney ? this.sharedService.trackApplicationResponse.data.applicantDetails.personalEmailId : this.sharedService.trackApplicationResponse.eapplyApplicantDetails.personalEmailId,
          'Pan':this.sharedService.fromSwiftJourney ? this.sharedService.trackApplicationResponse.data.applicantDetails.pan : this.sharedService.trackApplicationResponse.eapplyApplicantDetails.pan,
          'DOB' : this.sharedService.fromSwiftJourney ? this.sharedService.trackApplicationResponse.data.applicantDetails.dateOfBirth : this.sharedService.trackApplicationResponse.eapplyApplicantDetails.dateOfBirth
          });
      }
      if(window['analytics'] && this.sharedService && this.sharedService.qdeSubmitData){
        analytics.track('eapply__document_uploaded', {
  
          'MODE_OF_CONVERSION': '',
          'IS_ORGANIC': 'N',
          'SOURCE_GEM_ID1': this.sharedService.paramsgemid1,
          'SOURCE_GEM_ID2': this.sharedService.paramsgemid2,
          'SOURCE_PAGE_URL': window["digitalData"].page.SOURCE_PAGE_URL,
          'CHANNEL_NAME': this.sharedService.paramschannel,
          'JOURNEY_NAME': 'EAPPLY',
          'CITY': this.wsDetails.WSCallUserCity,
          'IS_DOCUMENT_UPLOADED': this.sharedService.navigateToDocUpload,
          'card_type' : this.sharedService.sbic_card_Type,
          'First_Name' : this.sharedService.qdeSubmitData.WSCallUserFirstName,
          'Last_Name' : this.sharedService.qdeSubmitData.WSCallUserLastName,
          'Mobile_No' :this.sharedService.qdeSubmitData.WSCallUserMobileNumber,
          'Email' :this.sharedService.qdeSubmitData.WSCallUserEmailId,
          'Pan':this.sharedService.qdeSubmitData.WSCallUserPanNumber,
          'DOB' : this.sharedService.qdeSubmitData.WSCallUserDOB
          });
      }

    }

    this.schedule_appointment = SCHEDULE_APPOINTMENT;
    setTimeout(() => { this.popupEnable = false; }, 5000);
    this.fetchAppointmentSlots();
    this.fetchAppointmentDetails();
    this.eapplySchAppointmentLabel = this.iw.geteapplyFormPostQDEDCR();
    this.errorTriangleImage = this.TATACARD ? './tata-card-en/resources/img/eapply/error-triangle.svg' : './sbi-card-en/resources/img/eapply/error-triangle.svg';
    this.blueTickImage = this.TATACARD ? './tata-card-en/resources/img/eapply/blue-tick-circle.svg' : './sbi-card-en/resources/img/eapply/blue-tick-circle.svg';
    this.applicantName = this.sharedService.applicantName
    this.applicantApplicationNumber = this.sharedService.applicantApplicationNumber
    if (this.sharedService.trackApplicationResponse) {
      if (this.sharedService.fromSwiftJourney) {
        if (this.sharedService.trackApplicationResponse.data.employmentDetails && this.sharedService.trackApplicationResponse.data.employmentDetails.occupationType) {
          let occupation: any;
          occupation = this.sharedService.trackApplicationResponse.data.employmentDetails.occupationType;
          (occupation == "P" || occupation == "T") ? (this.displayOffice = false) : (this.displayOffice = true)

        } else {
          this.displayOffice = false
        }
      }
      else {
        if (this.sharedService.trackApplicationResponse.eapplyEmploymentDetails && this.sharedService.trackApplicationResponse.eapplyEmploymentDetails.occupationType) {
          let occupation: any;
          occupation = this.sharedService.trackApplicationResponse.eapplyEmploymentDetails.occupationType;
          (occupation == "P" || occupation == "T") ? (this.displayOffice = false) : (this.displayOffice = true)

        } else {
          this.displayOffice = false
        }
      }


    } else {
      if (this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallUserOccupationCode) {
        let occupation: any;
        occupation = this.sharedService.qdeSubmitData.WSCallUserOccupationCode;
        (occupation == "P" || occupation == "T") ? (this.displayOffice = false) : (this.displayOffice = true)

      } else {
        this.displayOffice = false
      }
    }
    this.offerFlag=sessionStorage.getItem('offerFlag') && sessionStorage.getItem('offerFlag')==='true'?true:false;
    let channel: any;
    if (this.sharedService.trackApplicationResponse) {
      if(this.sharedService.fromSwiftJourney) {
        channel = this.sharedService.trackApplicationResponse.data.channelCode;
      }
      else {
        channel = this.sharedService.trackApplicationResponse.channelCode;
      }
    } else {
      channel = this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallChannelCode ? this.sharedService.qdeSubmitData.WSCallChannelCode : null;
    }

    if (channel ==='EALB' || this.sharedService.paramschannel =='901' || sessionStorage.getItem('channelId')=='901'){
      window["digitalData"].page = { pageName: 'sbi-card:banca appointment:campaign', pageType: 'Banca' };
    } else if(IS_CAMPAIGN || sessionStorage.getItem('campaign')=='true') {
      window["digitalData"].page = { pageName: 'sbi-card:eapply appointment:campaign', pageType: 'Campaign' };
    } else if(this.sharedService.paramsshortCode || sessionStorage.getItem('sc')){
      window["digitalData"].page = { pageName: 'sbi-card:reapply appointment:reapply', pageType: 'reapply' };
    } else {
      window["digitalData"].page = { pageName: 'sbi-card:eapply appointment:eapplyform', pageType: 'Eapply' };
    }
  }

  ngAfterViewInit(){
    let channel: any;
    if (this.sharedService.trackApplicationResponse) {
      if(this.sharedService.fromSwiftJourney) {
        channel = this.sharedService.trackApplicationResponse.data.channelCode;
      }
      else {
        channel = this.sharedService.trackApplicationResponse.channelCode;
      }
    } else {
      channel = this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallChannelCode ? this.sharedService.qdeSubmitData.WSCallChannelCode : null;
    }

    if (channel ==='EALB' || this.sharedService.paramschannel =='901' || sessionStorage.getItem('channelId')=='901'){
      window["digitalData"].page = { pageName: 'sbi-card:banca appointment:campaign', pageType: 'Banca' };
    } else if(IS_CAMPAIGN || sessionStorage.getItem('campaign')=='true') {
      window["digitalData"].page = { pageName: 'sbi-card:eapply appointment:campaign', pageType: 'Campaign' };
    } else if(this.sharedService.paramsshortCode || sessionStorage.getItem('sc')){
      window["digitalData"].page = { pageName: 'sbi-card:reapply appointment:reapply', pageType: 'reapply' };
    } else {
      window["digitalData"].page = { pageName: 'sbi-card:eapply appointment:eapplyform', pageType: 'Eapply' };
    }
  }

  fetchAppointmentSlots() {
    this.appointmentService.fetchAppointmentSlot().subscribe((response: any) => {
      const res = { ...response.body };
      if (res && res.FetchAppointmentSlotRsType && res.FetchAppointmentSlotRsType.slots) {
        let accessToken: any;
        let expiryTime: any;
        if (response.headers && response.headers.get("access_token")) {
          accessToken = response.headers.get("access_token");
        }
        if (response.headers && response.headers.get("expiry_time")) {
          expiryTime = response.headers.get("expiry_time");
        }

        if (accessToken) {
          sessionStorage.setItem("s24_access_token", accessToken);
        }
        if (expiryTime) {
          sessionStorage.setItem("s24_expiry_time", expiryTime);
        }
        this.fetchAppointmentSlotsDetails = res.FetchAppointmentSlotRsType;
        this.slots = res.FetchAppointmentSlotRsType.slots;
        this.dates = res.FetchAppointmentSlotRsType.dates;
        this.errorBookAppointment = '';
      } else {
        this.errorBookAppointment = GENERIC_ERROR;
        window["digitalData"].error = { message: this.errorBookAppointment };
        if(window['_satellite']){
          _satellite.track('form_error');
        }
      }
    }), error => {
      this.errorBookAppointment = GENERIC_ERROR;
      window["digitalData"].error = { message: this.errorBookAppointment };
      if(window['_satellite']){
        _satellite.track('form_error');
      }
    }
  }

  fetchAppointmentDetails() {
    this.docUploadStatus = this.sharedService.navigateToDocUpload;
    if (this.sharedService.trackApplicationResponse) {
      if (this.sharedService.fromSwiftJourney) {
        this.fetchAppointment = this.sharedService.trackApplicationResponse.data.appointmentDetails;
        this.fetchAppointmentFlag = (!this.sharedService.navigateToScheduleAppointment) ? this.sharedService.navigateToResheduleAppointment : false;
        this.docUploadStatus = this.sharedService.navigateToDocUpload;
      }
      else {
        this.fetchAppointment = this.sharedService.trackApplicationResponse.appointmentDetails;
        this.fetchAppointmentFlag = (!this.sharedService.navigateToScheduleAppointment) ? this.sharedService.navigateToResheduleAppointment : false;
        this.docUploadStatus = this.sharedService.navigateToDocUpload;
      }
      
    }
  }

  bookAppointment() {
    if(this.disableBookAppointment){
      return;
    }
    book_appointment(this.selected.date + '|' + this.timeSlot + '|' + this.location);
    this.getSelectedAddress();
    if (this.sharedService.trackApplicationResponse) {
      console.log('BookAppointment, inside if block');
      this.bookAppointmentRequestBody = {
        "dateOfPickUp": this.selected.date || "",
        "slotStartTime": this.slotSelected.slotStartTimeStr || "",
        "slotEndTime": this.slotSelected.slotEndTimeStr || "",
        "pickUpLocation": this.addType || "",
        "addressLine1": this.addressLine1 || "",
        "addressLine2": this.addressLine2 || "",
        "pinCode": this.pinCode || "",
        "city": this.city || "",
        "state": this.state || "",
        "landMark": this.landmark || "",
        "applicationNumber": this.sharedService.fromSwiftJourney ? this.sharedService.trackApplicationResponse.data.applicationNumber : this.sharedService.trackApplicationResponse.applicationNumber || null,
        "cardType":this.sharedService.sbic_card_Type || "",
        "channelCode": this.sharedService.fromSwiftJourney ? this.sharedService.trackApplicationResponse.data.channelCode : this.sharedService.trackApplicationResponse.channelCode || "",
        "cityList":"Y"
      };
    } else {
      console.log('BookAppointment, inside else block');
      this.bookAppointmentRequestBody = {
        "dateOfPickUp": this.selected.date || "",
        "slotStartTime": this.slotSelected.slotStartTimeStr || "",
        "slotEndTime": this.slotSelected.slotEndTimeStr || "",
        "pickUpLocation": this.addType || "",
        "addressLine1": this.addressLine1 || "",
        "addressLine2": this.addressLine2 || "",
        "pinCode": this.pinCode || "",
        "city": this.city || "",
        "state": this.state || "",
        "landMark": this.landmark || "",
        "applicationNumber": this.sharedService.qdeSuccessResponse.applicationNumber || null
      };
    }
    console.log("Req for bookAppointment ==> ", this.bookAppointmentRequestBody);
    this.appointmentService.bookAppointment(this.bookAppointmentRequestBody).subscribe((response: any) => {
      const res = { ...response.body };
      if (res) {
        if (res.BookAppointmentErrorRsType && res.BookAppointmentErrorRsType.status && res.BookAppointmentErrorRsType.status == "Failure") {
          if (res.BookAppointmentErrorRsType.errorCode && res.BookAppointmentErrorRsType.errorCode == '100') {
            this.disableBookAppointment = 0;
            this.errorBookAppointment = BRAND_APPROVED_ERRORS.invalidRequest;
          } else if (res.BookAppointmentErrorRsType.errorCode && res.BookAppointmentErrorRsType.errorCode == '104') {
            const message = BRAND_APPROVED_ERRORS.appProccessBySales24.replace(/<card type>/g, this.sharedService.sbic_card_Type);
            this.errorBookAppointment = message;
            this.disableBookAppointment = 0;
          } else if (res.BookAppointmentErrorRsType.errorCode && res.BookAppointmentErrorRsType.errorCode == '301') {
            const message = res.BookAppointmentErrorRsType.errorMessage;
            this.errorBookAppointment = message;
            this.disableBookAppointment = 0;
          } else {
            this.disableBookAppointment = 0;
            this.errorBookAppointment = res.BookAppointmentErrorRsType.errorMessage
          }
          window["digitalData"].error = { message: this.errorBookAppointment };
          if(window['_satellite']){
            _satellite.track('form_error');
          }
        } else if (res.BookAppointmentRsType && res.BookAppointmentRsType.status && res.BookAppointmentRsType.status == "Success") {
          this.disableBookAppointment = 1;
          let accessToken: any;
          let expiryTime: any;
          if (response.headers && response.headers.get("access_token")) {
            accessToken = response.headers.get("access_token");
          }
          if (response.headers && response.headers.get("expiry_time")) {
            expiryTime = response.headers.get("expiry_time");
          }

          if (accessToken) {
            sessionStorage.setItem("s24_access_token", accessToken);
          }
          if (expiryTime) {
            sessionStorage.setItem("s24_expiry_time", expiryTime);
          }
          this.errorBookAppointment = '';
          this.bookAppointmentDetails = res;
          if ((this.sharedService.navigateToAddon) || (this.sharedService.navigateToCrossSell)) {
            this.router.navigate(['/', 'addon-card']);
          }
          else {
            this.router.navigate(['/', 'success']);
          }
        }
      }
    }, err => {
      this.disableBookAppointment = 0;
      this.errorBookAppointment = GENERIC_ERROR;
      window["digitalData"].error = { message: GENERIC_ERROR };
      if(window['_satellite']){
        _satellite.track('form_error');
      }
    });
  
  if(!this.sharedService.fromSwiftJourney){
    /* Analytics added */
    if(window['analytics']){
      analytics.track('eapply__click__book', {
        'MODE_OF_CONVERSION': '',
        'IS_ORGANIC': 'N',
        'SOURCE_GEM_ID1': this.sharedService.paramsgemid1,
        'SOURCE_GEM_ID2': this.sharedService.paramsgemid2,
        'SOURCE_PAGE_URL': window["digitalData"].page.SOURCE_PAGE_URL,
        'CHANNEL_NAME': this.sharedService.paramschannel,
        'JOURNEY_NAME': 'EAPPLY',
        'First_Name' : this.sharedService.qdeSubmitData.WSCallUserFirstName ? this.sharedService.qdeSubmitData.WSCallUserFirstName : this.sharedService.fromSwiftJourney ? this.sharedService.trackApplicationResponse.data.applicantDetails.firstName : this.sharedService.trackApplicationResponse.eapplyApplicantDetails.firstName, 
        'Last_Name' : this.sharedService.qdeSubmitData.WSCallUserLastName? this.sharedService.qdeSubmitData.WSCallUserLastName :this.sharedService.fromSwiftJourney ? this.sharedService.trackApplicationResponse.data.applicantDetails.lastName : this.sharedService.trackApplicationResponse.eapplyApplicantDetails.lastName,
        'Mobile_No' :this.sharedService.qdeSubmitData.WSCallUserMobileNumber? this.sharedService.qdeSubmitData.WSCallUserMobileNumber: this.sharedService.fromSwiftJourney ? this.sharedService.trackApplicationResponse.data.applicantDetails.mobileNumber : this. sharedService.trackApplicationResponse.eapplyApplicantDetails.mobileNumber,
        'Email' :this.sharedService.qdeSubmitData.WSCallUserEmailId? this.sharedService.qdeSubmitData.WSCallUserEmailId: this.sharedService.fromSwiftJourney ? this.sharedService.trackApplicationResponse.data.applicantDetails.personalEmailId : this.sharedService.trackApplicationResponse.eapplyApplicantDetails.personalEmailId,
        'Pan':this.sharedService.qdeSubmitData.WSCallUserPanNumber? this.sharedService.qdeSubmitData.WSCallUserPanNumber : this.sharedService.fromSwiftJourney ? this.sharedService.trackApplicationResponse.data.applicantDetails.pan : this.sharedService.trackApplicationResponse.eapplyApplicantDetails.pan,
        'DOB' : this.sharedService.qdeSubmitData.WSCallUserDOB? this.sharedService.qdeSubmitData.WSCallUserDOB : this.sharedService.fromSwiftJourney ? this.sharedService.trackApplicationResponse.data.applicantDetails.dateOfBirth : this.sharedService.trackApplicationResponse.eapplyApplicantDetails.dateOfBirth,
        'CARD_TYPE': this.sharedService.sbic_card_Type
        });
    }

  }
  
  
  
  
  }


  getSelectedAddress() {
    if (this.sharedService.trackApplicationResponse) {
      if(this.sharedService.fromSwiftJourney) {
        if (this.addSelected == "Office") {
          this.addType = "O";
          if (this.sharedService.trackApplicationResponse.data.officeAddress) {
            this.addressLine1 = this.sharedService.trackApplicationResponse.data.officeAddress.offAddressLine1 ? this.sharedService.trackApplicationResponse.data.officeAddress.offAddressLine1 : null
            this.addressLine2 = this.sharedService.trackApplicationResponse.data.officeAddress.offAddressLine2 ? this.sharedService.trackApplicationResponse.data.officeAddress.offAddressLine2 : null
            this.pinCode = this.sharedService.trackApplicationResponse.data.officeAddress.offPinCode ? this.sharedService.trackApplicationResponse.data.officeAddress.offPinCode : null
            this.city = this.sharedService.trackApplicationResponse.data.officeAddress.offCity ? this.sharedService.trackApplicationResponse.data.officeAddress.offCity : null
            this.state = this.sharedService.trackApplicationResponse.data.officeAddress.offState ? this.sharedService.trackApplicationResponse.data.officeAddress.offState : null
            this.landmark = this.sharedService.trackApplicationResponse.data.officeAddress.offAddressLine3 ? this.sharedService.trackApplicationResponse.data.officeAddress.offAddressLine3 : null
          }
        }
        else if (this.addSelected == "Current Address") {
          this.addType = "R";
          if (this.sharedService.trackApplicationResponse.data.contactDetails) {
            this.addressLine1 = this.sharedService.trackApplicationResponse.data.contactDetails.resiAddressLine1 ? this.sharedService.trackApplicationResponse.data.contactDetails.resiAddressLine1 : null
            this.addressLine2 = this.sharedService.trackApplicationResponse.data.contactDetails.resiAddressLine2 ? this.sharedService.trackApplicationResponse.data.contactDetails.resiAddressLine2 : null
            this.pinCode = this.sharedService.trackApplicationResponse.data.contactDetails.resiPinCode ? this.sharedService.trackApplicationResponse.data.contactDetails.resiPinCode : null
            this.city = this.sharedService.trackApplicationResponse.data.contactDetails.resiCity ? this.sharedService.trackApplicationResponse.data.contactDetails.resiCity : null
            this.state = this.sharedService.trackApplicationResponse.data.contactDetails.resiState ? this.sharedService.trackApplicationResponse.data.contactDetails.resiState : null
            this.landmark = this.sharedService.trackApplicationResponse.data.contactDetails.resiAddressLine3 ? this.sharedService.trackApplicationResponse.data.contactDetails.resiAddressLine3 : null
          }
        }
      }
      else {
        if (this.addSelected == "Office") {
          this.addType = "O";
          if (this.sharedService.trackApplicationResponse.officeAddress) {
            this.addressLine1 = this.sharedService.trackApplicationResponse.officeAddress.offAddressLine1 ? this.sharedService.trackApplicationResponse.officeAddress.offAddressLine1 : null
            this.addressLine2 = this.sharedService.trackApplicationResponse.officeAddress.offAddressLine2 ? this.sharedService.trackApplicationResponse.officeAddress.offAddressLine2 : null
            this.pinCode = this.sharedService.trackApplicationResponse.officeAddress.offPinCode ? this.sharedService.trackApplicationResponse.officeAddress.offPinCode : null
            this.city = this.sharedService.trackApplicationResponse.officeAddress.offCity ? this.sharedService.trackApplicationResponse.officeAddress.offCity : null
            this.state = this.sharedService.trackApplicationResponse.officeAddress.offState ? this.sharedService.trackApplicationResponse.officeAddress.offState : null
            this.landmark = this.sharedService.trackApplicationResponse.officeAddress.offAddressLine3 ? this.sharedService.trackApplicationResponse.officeAddress.offAddressLine3 : null
          }
        }
        else if (this.addSelected == "Current Address") {
          this.addType = "R";
          if (this.sharedService.trackApplicationResponse.eapplyContactDetails) {
            this.addressLine1 = this.sharedService.trackApplicationResponse.eapplyContactDetails.resiAddress1 ? this.sharedService.trackApplicationResponse.eapplyContactDetails.resiAddress1 : null
            this.addressLine2 = this.sharedService.trackApplicationResponse.eapplyContactDetails.resiAddress2 ? this.sharedService.trackApplicationResponse.eapplyContactDetails.resiAddress2 : null
            this.pinCode = this.sharedService.trackApplicationResponse.eapplyContactDetails.resiPin ? this.sharedService.trackApplicationResponse.eapplyContactDetails.resiPin : null
            this.city = this.sharedService.trackApplicationResponse.eapplyContactDetails.resiCity ? this.sharedService.trackApplicationResponse.eapplyContactDetails.resiCity : null
            this.state = this.sharedService.trackApplicationResponse.eapplyContactDetails.resiState ? this.sharedService.trackApplicationResponse.eapplyContactDetails.resiState : null
            this.landmark = this.sharedService.trackApplicationResponse.eapplyContactDetails.resiAddress3 ? this.sharedService.trackApplicationResponse.eapplyContactDetails.resiAddress3 : null
          }
        }
      }
      
      /*  else if (this.addSelected == "Permanent Address") {
          this.addType = "P";
          if (this.sharedService.trackApplicationResponse.eapplyContactDetails) {
            this.addressLine1 = this.sharedService.trackApplicationResponse.eapplyContactDetails.permAddressLine1 ? this.sharedService.trackApplicationResponse.eapplyContactDetails.permAddressLine1 : null
            this.addressLine2 = this.sharedService.trackApplicationResponse.eapplyContactDetails.permAddressLine2 ? this.sharedService.trackApplicationResponse.eapplyContactDetails.permAddressLine2 : null
            this.pinCode = this.sharedService.trackApplicationResponse.eapplyContactDetails.resiPin ? this.sharedService.trackApplicationResponse.eapplyContactDetails.permPinCode : null
            this.city = this.sharedService.trackApplicationResponse.eapplyContactDetails.permCity ? this.sharedService.trackApplicationResponse.eapplyContactDetails.permCity : null
            this.state = this.sharedService.trackApplicationResponse.eapplyContactDetails.permState ? this.sharedService.trackApplicationResponse.eapplyContactDetails.permState : null
            this.landmark = this.sharedService.trackApplicationResponse.eapplyContactDetails.permLandmark ? this.sharedService.trackApplicationResponse.eapplyContactDetails.permLandmark : null
          }
        } */
    } else {
      if (this.addSelected == "Office") {
        this.addType = "O";
        this.addressLine1 = this.sharedService.cAprofessisonalData ? this.sharedService.cAprofessisonalData.WSCallUserOffAddLine1 : null;
        this.addressLine2 = this.sharedService.cAprofessisonalData ? this.sharedService.cAprofessisonalData.WSCallUserOffAddLine2 : null;
        this.pinCode = this.sharedService.cAprofessisonalData ? this.sharedService.cAprofessisonalData.WSCallUserResiPincode : null;
        this.city = this.sharedService.officeCity;
        this.state = this.sharedService.officeState;
        this.landmark = this.sharedService.cAprofessisonalData ? this.sharedService.cAprofessisonalData.WSCallUserOffLandmark : null;
      } else if (this.addSelected == "Current Address") {

        this.addType = "R";
        this.addressLine1 = this.sharedService.qdeSubmitData ? this.sharedService.qdeSubmitData.WSCallUserHouseNo : null;
        this.addressLine2 = this.sharedService.qdeSubmitData ? this.sharedService.qdeSubmitData.WSCallUserAddressLine : null;
        this.pinCode = this.sharedService.qdeSubmitData ? this.sharedService.qdeSubmitData.WSCallUserResiPincode : null;
        this.city = this.sharedService.qdeSubmitData ? this.sharedService.qdeSubmitData.WSCallUserCity : null;
        this.state = this.sharedService.resiState;
        this.landmark = this.sharedService.qdeSubmitData ? this.sharedService.qdeSubmitData.WSCallUserLocality : null;

      }
    }

  }

  fetchDate(date) {
    this.selected = date;
    this.nationalHolidayFlag = this.selected.isNationalHoliday;
  }

  fetchSlot(slot) {
    this.timeSlot = slot;
    this.slotSelected = slot;
  }
  
  fetchAdd(address) {
    this.location = address
    this.addSelected = address;
    this.flag = true;
  }

  skipAppointment() {
    if(window['_satellite']){
      _satellite.track("skip_appointment");
    }
    if ((this.sharedService.navigateToAddon) || (this.sharedService.navigateToCrossSell)) {
      this.router.navigate(['/', 'addon-card']);
    }
    else {
      this.router.navigate(['/', 'success']);
    }

    if(!this.sharedService.fromSwiftJourney) {
      /* Analytics added */
      if(window['analytics']){
        analytics.track('eapply__click__skip_appiontment', {
          'IS_ORGANIC': 'N',
          'SOURCE_GEM_ID1': this.sharedService.paramsgemid1,
          'SOURCE_GEM_ID2': this.sharedService.paramsgemid2,
          'SOURCE_PAGE_URL': window["digitalData"].page.SOURCE_PAGE_URL,
          'CHANNEL_NAME': this.sharedService.paramschannel,
          'JOURNEY_NAME': 'EAPPLY',
          'First_Name' : this.sharedService.qdeSubmitData.WSCallUserFirstName ? this.sharedService.qdeSubmitData.WSCallUserFirstName : this.sharedService.fromSwiftJourney ? this.sharedService.trackApplicationResponse.data.applicantDetails.firstName : this.sharedService.trackApplicationResponse.eapplyApplicantDetails.firstName,
          'Last_Name' : this.sharedService.qdeSubmitData.WSCallUserLastName? this.sharedService.qdeSubmitData.WSCallUserLastName : this.sharedService.fromSwiftJourney ? this.sharedService.trackApplicationResponse.data.applicantDetails.lastName : this.sharedService.trackApplicationResponse.eapplyApplicantDetails.lastName,
          'Mobile_No' :this.sharedService.qdeSubmitData.WSCallUserMobileNumber? this.sharedService.qdeSubmitData.WSCallUserMobileNumber: this.sharedService.fromSwiftJourney ? this.sharedService.trackApplicationResponse.data.applicantDetails.mobileNumber : this.sharedService.trackApplicationResponse.eapplyApplicantDetails.mobileNumber,
          'Email' :this.sharedService.qdeSubmitData.WSCallUserEmailId? this.sharedService.qdeSubmitData.WSCallUserEmailId: this.sharedService.fromSwiftJourney ? this.sharedService.trackApplicationResponse.data.applicantDetails.personalEmailId : this.sharedService.trackApplicationResponse.eapplyApplicantDetails.personalEmailId,
          'Pan':this.sharedService.qdeSubmitData.WSCallUserPanNumber? this.sharedService.qdeSubmitData.WSCallUserPanNumber : this.sharedService.fromSwiftJourney ? this.sharedService.trackApplicationResponse.data.applicantDetails.pan : this.sharedService.trackApplicationResponse.eapplyApplicantDetails.pan,
          'DOB' : this.sharedService.qdeSubmitData.WSCallUserDOB? this.sharedService.qdeSubmitData.WSCallUserDOB : this.sharedService.fromSwiftJourney ? this.sharedService.trackApplicationResponse.data.applicantDetails.dateOfBirth : this.sharedService.trackApplicationResponse.eapplyApplicantDetails.dateOfBirth,
          'CARD_TYPE': this.sharedService.sbic_card_Type
          });
      }

    }
    
  }

  goToDocUpload() {
    let channel: any;
    let appNumber: any;
    let data = window['digitalData'];
    if (this.sharedService.trackApplicationResponse) {
      channel = this.sharedService.fromSwiftJourney ? this.sharedService.trackApplicationResponse.data.channelCode : this.sharedService.trackApplicationResponse.channelCode;
    } else {
      channel = this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallChannelCode ? this.sharedService.qdeSubmitData.WSCallChannelCode : null;
    }

    if(channel ==='EALB' || this.sharedService.paramschannel =='901' || sessionStorage.getItem('channelId')=='901'){
      data.page = { pageName: 'sbi-card:banca doc-upload:campaign', pageType: 'Banca' };
    } else if (IS_CAMPAIGN) {
      data.page = { pageName: 'sbi-card:eapply doc-upload:campaign', pageType: 'Campaign' };
    } else if(this.sharedService.paramsshortCode || sessionStorage.getItem('sc')){
      data.page = { pageName: 'sbi-card:reapply doc-upload:reapply', pageType: 'reapply' };
    } else {
      data.page = { pageName: 'sbi-card:eapply doc-upload:eapplyform', pageType: 'Eapply' };
    }
    sessionStorage.setItem('digitalData', JSON.stringify(data));
    if(window['_satellite']){
      _satellite.track("doc_upload");
    }
    // sessionStorage.setItem('trackResponse', JSON.stringify(this.sharedService.trackApplicationResponse));
    // sessionStorage.setItem('appNo', this.sharedService.trackApplicationResponse.applicationNumber);
    if (this.sharedService.trackApplicationResponse) {
      if (this.sharedService.fromSwiftJourney) {
        sessionStorage.setItem('trackResponse', JSON.stringify(this.sharedService.trackApplicationResponse));
        appNumber = this.sharedService.trackApplicationResponse.data.applicationNumber;
        sessionStorage.setItem('appNo', this.sharedService.trackApplicationResponse.data.applicationNumber);
      }
      else  {
        sessionStorage.setItem('trackResponse', JSON.stringify(this.sharedService.trackApplicationResponse));
        appNumber = this.sharedService.trackApplicationResponse.applicationNumber;
        sessionStorage.setItem('appNo', this.sharedService.trackApplicationResponse.applicationNumber);
      }
    } else {
      sessionStorage.setItem('offAdd', JSON.stringify(this.sharedService.cAprofessisonalData));
      sessionStorage.setItem('currentAdd', JSON.stringify(this.sharedService.qdeSubmitData));
      sessionStorage.setItem('perAdd', JSON.stringify(this.sharedService.cApersonalData));
      sessionStorage.setItem('qdeResponseFlags', JSON.stringify(this.sharedService.flagsFromQdeResponse));
      sessionStorage.setItem('appNo', this.sharedService.qdeSuccessResponse.applicationNumber);
      sessionStorage.setItem('applicantName', this.sharedService.applicantName);
      appNumber = this.sharedService.qdeSuccessResponse.applicationNumber
      sessionStorage.setItem('officeCity', this.sharedService.officeCity);
      sessionStorage.setItem('officeState', this.sharedService.officeState);
      sessionStorage.setItem('resiState', this.sharedService.resiState);
      sessionStorage.setItem('cardName', this.sharedService.cardName);
      sessionStorage.setItem('cardType', this.sharedService.sbic_card_Type);
    }

    let requestApp = {
      "applicationNumber": appNumber
    }
    this.sharedService.getExpandUrlForDocUplod(requestApp).subscribe((response: any) => {
      console.log("fetch params from schedule appoinment component 625");
      const res = { ...response.body };
      if (res && res.FetchDocUploadParamsRsType && res.FetchDocUploadParamsRsType.status) {
        let accessToken: any;
        let expiryTime: any;
        if (response.headers && response.headers.get("access_token")) {
          accessToken = response.headers.get("access_token");
        }
        if (response.headers && response.headers.get("expiry_time")) {
          expiryTime = response.headers.get("expiry_time");
        }

        if (accessToken) {
          sessionStorage.setItem("s24_access_token", accessToken);
        }
        if (expiryTime) {
          sessionStorage.setItem("s24_expiry_time", expiryTime);
        }
        sessionStorage.setItem('eAppId', res.FetchDocUploadParamsRsType.applicationId);
        sessionStorage.setItem('eVerificationCode', res.FetchDocUploadParamsRsType.verificationCode);
        this.createHiddenForm();

      } else {
        this.createHiddenForm();
        window["digitalData"].error = { message: this.errorBookAppointment };
        if(window['_satellite']){
          _satellite.track('form_error');
        }
      }
    }, err => {
      this.createHiddenForm();
      window["digitalData"].error = { message: this.errorBookAppointment };
      if(window['_satellite']){
        _satellite.track('form_error');
      }
    })
  }

  createHiddenForm() {
    var form = document.createElement("form");
    form.method = "POST";
    form.action = DOC_UPLOAD_LINK;
    document.body.appendChild(form);
    form.submit();
  }
}



